import { render, staticRenderFns } from "./AI_Function_Menu.vue?vue&type=template&id=35b25080&scoped=true"
import script from "./AI_Function_Menu.vue?vue&type=script&lang=js"
export * from "./AI_Function_Menu.vue?vue&type=script&lang=js"
import style0 from "./AI_Function_Menu.vue?vue&type=style&index=0&id=35b25080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b25080",
  null
  
)

export default component.exports